export default __webpack_public_path__ + "static/media/bobbleMedium.cf80a2cb.svg";